export default __webpack_public_path__ + "assets/images/ac55276564344b9ef7da65b72ded5575.png";